import { render, staticRenderFns } from "./widgetSecThreatMachIdTop10.vue?vue&type=template&id=23076300&scoped=true&"
import script from "./widgetSecThreatMachIdTop10.vue?vue&type=script&lang=js&"
export * from "./widgetSecThreatMachIdTop10.vue?vue&type=script&lang=js&"
import style0 from "./widgetSecThreatMachIdTop10.vue?vue&type=style&index=0&id=23076300&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23076300",
  null
  
)

export default component.exports